import { Directive, Input, OnInit, HostListener, Self, Host, Optional, Output, EventEmitter, OnChanges, SimpleChanges, DoCheck, KeyValueDiffer, KeyValueDiffers } from '@angular/core';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { LookupGridComponent } from '@farris/ui-lookup';
import { ComboListComponent } from '@farris/ui-combo-list';
import { ComboLookupComponent } from '@farris/ui-combo-lookup';

@Directive({
  selector: '[UIStateBinding]'
})
export class UIStateBindingDirective implements OnInit, OnChanges, DoCheck {
  private _bindingObject: any;
  private readonly defaultSpliter = ',';
  private differ: KeyValueDiffer<any, any> = null;

  @Input('UIStateBinding')
  set bindingObject(value: any) {
    this._bindingObject = value;
    if (!this.differ && value && this.differs && typeof (value) === 'object') {
      this.differ = this.differs.find(value).create();
    }
  }
  get bindingObject() {
    return this._bindingObject;
  }
  @Output() UIStateBindingChange: EventEmitter<any> = new EventEmitter<any>();

  @HostListener('valueChange', ['$event'])
  onValueChange(val: any) {
    // host is combobox
    if (this.hostComboComponent && this.bindingObject) {
      if (val) {
        this.bindingObject.key = val.value;
        this.bindingObject.value = val.name;
      } else {
        this.bindingObject.key = null;
        this.bindingObject.value = null;
      }
    }
  }

  constructor(
    @Host() @Self() @Optional() private hostComboComponent: ComboBoxComponent,
    @Host() @Self() @Optional() private hostHelpComponent: LookupGridComponent,
    @Optional() private differs: KeyValueDiffers,
    @Host() @Self() @Optional() private hostComboListComponent: ComboListComponent,
    @Host() @Self() @Optional() private hostComboLookupComponent: ComboLookupComponent
  ) { }

  ngOnInit() {
    if (this.hostComboComponent) {
      this.hostComboComponent.valuePrimitive = false;
    } else if (this.hostHelpComponent) {
      this.bindObjectToHostLookup();
    } else if (this.hostComboListComponent) {
      this.bindObjectToHostComboList();
    } else if (this.hostComboLookupComponent) {
      this.bindObjectToHostComboLookup();
    }
  }
  ngDoCheck() {
    if (this.differ && typeof (this.bindingObject) === 'object') {
      const changes = this.differ && this.differ.diff(this.bindingObject);
      if (changes) {
        this.bindingChanges();
      }
    } else { // å¼å®¹æªéæ°ç¼è¯å·¥ç¨ï¼differä¸å­å¨ä»æåµ
      this.bindingChanges();
    }
  }

  private bindingChanges() {
    const text = this.bindingObject ? this.bindingObject.value : null;
    const key = this.bindingObject ? this.bindingObject.key : null;
    if (this.hostComboComponent) {
      this.hostComboComponent.text = text;
      const vField = this.hostComboComponent.valueField;
      const item = this.hostComboComponent.data.find((n) => n[vField] === key);
      this.hostComboComponent.writeValue(item);
    } else if (this.hostHelpComponent) {
      this.hostHelpComponent.writeValue(text);
      this.hostHelpComponent.displayValue = key;
    } else if (this.hostComboListComponent) {
      this.hostComboListComponent.writeValue(key);
    } else if (this.hostComboLookupComponent) {
      this.hostComboLookupComponent.selectedValues = key;
      this.hostComboLookupComponent.writeValue(text);
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.bindingObject && !this.differ) {
      this.bindingChanges();
    }
  }

  // å¼¹åºå¸®å©
  private bindObjectToHostLookup() {
    if (!this.hostHelpComponent) {
      return;
    }

    this.hostHelpComponent.selectedData.subscribe((data: any) => this.updateHelpBindingObject(data));

    this.hostHelpComponent.clear.subscribe(() => {
      // this.bindingObject = {key: null, value: null};
      this.updateHelpBindingObject(null);
    });
    if (this.hostHelpComponent.tagRemoved) {
      this.hostHelpComponent.tagRemoved.subscribe((event: { removedIndex: number, instance: LookupGridComponent }) => {
        const { removedIndex: index = -1, instance: componentRef = null } = event;
        if (index === -1) {
          return;
        }
        const isSigleSelect = componentRef.singleSelect;
        if (isSigleSelect || !componentRef.displayValue) {
          this.updateHelpBindingObject(null);
        } else {
          this.UIStateBindingChange.emit({ key: componentRef.displayValue, value: componentRef.displayText });
        }
      });
    }
    if (this.hostHelpComponent.nosearch) {
      this.hostHelpComponent.valueChanged.subscribe((txt: any) => {
        const idField = this.hostHelpComponent.idField;
        const textField = this.hostHelpComponent.textField;
        this.updateHelpBindingObject({
          [idField]: txt,
          [textField]: txt
        });
      });
    }
  }

  // ä¸æåè¡¨
  private bindObjectToHostComboList() {
    if (!this.hostComboListComponent) {
      return;
    }

    this.hostComboListComponent.valueChange.subscribe((data: any) => this.updateHelpBindingObject(data.selections));

    this.hostComboListComponent.clear.subscribe(() => {
      this.updateHelpBindingObject(null);
    });
  }

  // ä¸æå¸®å©
  private bindObjectToHostComboLookup() {
    if (!this.hostComboLookupComponent) {
      return;
    }

    if (this.hostComboLookupComponent.multiSelect) {
      this.hostComboLookupComponent.valueChange.subscribe((data: any) => this.updateHelpBindingObject(data.selections));
    } else {
      // this.hostComboLookupComponent.selectChange.subscribe((data: any) => this.updateHelpBindingObject(data));
      this.hostComboLookupComponent.selectChange.subscribe((e: any) => {
        let data = e;
        if (e.data) {
          data = e.data;
        }
        this.updateHelpBindingObject(data);
      });
    }

    this.hostComboLookupComponent.clear.subscribe(() => {
      this.updateHelpBindingObject(null);
    });
  }

  // æ´æ°UISTATE
  private updateHelpBindingObject(data: any) {
    let idField;
    let textField;
    let spliter: string = this.defaultSpliter;
    if (this.hostHelpComponent) {
      idField = this.hostHelpComponent.idField;
      textField = this.hostHelpComponent.textField;
      spliter = this.hostHelpComponent.multipleChoiceSeparator || this.defaultSpliter;
    }

    if (this.hostComboListComponent) {
      idField = this.hostComboListComponent.idField;
      textField = this.hostComboListComponent.textField;
    }

    if (this.hostComboLookupComponent) {
      idField = this.hostComboLookupComponent.idField;
      textField = this.hostComboLookupComponent.textField;
      spliter = this.hostComboLookupComponent.separator || this.defaultSpliter;
    }

    this.emitUiStateBinding(data, idField, textField, spliter);
  }

  private emitUiStateBinding(data, idField, textField, spliter: string = ',') {
    const newObject = { key: null, value: null };
    if (data) {
      // const idField = this.hostHelpComponent.idField;
      // const textField = this.hostHelpComponent.textField;
      if (Array.isArray(data)) {
        newObject.key = data.map((d) => d[idField]).join(spliter);
        newObject.value = data.map((d) => {
          if (textField.indexOf('.') > -1) {
            return textField.split('.').reduce((r, c) => {
              return r[c];
            }, d);
          } else {
            return d[textField];
          }
        }).join(spliter);
      } else {
        if (idField) {
          newObject.key = data[idField];
        }

        if (textField) {
          if (textField.indexOf('.') > -1) {
            newObject.value = textField.split('.').reduce((r, c) => {
              return r[c];
            }, data);
          } else {
            newObject.value = data[textField];
          }
        }
      }
    }
    this.UIStateBindingChange.emit(newObject);
  }
}
